import React, { useEffect, createElement } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { BookingPage } from './pages/BookingPage';
import { ThankYouPage } from './pages/ThankYouPage';
function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  // Initialize Meta Pixel
  useEffect(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    f.fbq('init', '3786982544942566');
    f.fbq('track', 'PageView');
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=3786982544942566&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  // Preload the booking script as soon as the app mounts
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.yourmarketingai.com/js/form_embed.js';
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <Routes data-id="element-0">
      <Route path="/" element={<LandingPage onNavigateToBooking={() => navigate('/booking')} data-id="element-2" />} data-id="element-1" />
      <Route path="/booking" element={<BookingPage onBack={() => navigate('/')} data-id="element-4" />} data-id="element-3" />
      <Route path="/thank-you" element={<ThankYouPage onBack={() => navigate('/')} data-id="element-6" />} data-id="element-5" />
    </Routes>;
}
export function App() {
  return <AppContent data-id="element-7" />;
}